import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from './utils/user.service';
import { StorageService } from './storage-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router,
    private storage: StorageService
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    if (this.userService.isUserLoggedIn) {
      return true;
    }

    const token = await this.storage.get('token');
    if (token) {
      this.userService.isUserLoggedIn = true;
      return true;
    }

    return this.router.createUrlTree(['/welcome']);
  }
}
